/**
 *
 * @param {string} text
 * @returns {string}
 */
export function createUsername(text) {
	return text.toString().trim().toLowerCase().replace(/\s+/g, "");
}
